import * as Yup from "yup";
import { KeyValueMap } from "../../../../../../../../../redux/slices/appState/models";
import {
  InvoiceReversalFormKey,
  RaiseInvoicePODetailsFormKey,
} from "../../../../../../../modelsAndSchemas/Models";
import {
  EXTENDED_SPECIAL_CHARS,
  INPUT_LIMIT,
  INVOICE_REVERSAL_REASON_OTHERS_SITE_CORE_KEY,
  MAX_LENGTH_100,
} from "../../../../../../../../../helpers/constants";
import { commonSiteCoreKeys } from "../../../../../../../../../helpers/constants/siteCoreKeys";

export const RaiseInvoiceModalSchema = (
  commonValidationMessages: KeyValueMap,
) =>
  Yup.object().shape({
    [RaiseInvoicePODetailsFormKey.localInvoiceNumber]: Yup.string()
      .optional()
      .test(
        "is-valid",
        commonValidationMessages.onlyAlphanumericSpacesAndHyphenAllowed,
        (value) =>
          !value || INPUT_LIMIT.ALPHA_NUMERIC_WITH_DASH_AND_SPACE.test(value),
      )
      .default(""),
    [RaiseInvoicePODetailsFormKey.poNumber]: Yup.string(),
    [RaiseInvoicePODetailsFormKey.currentPOBalance]: Yup.string(),
    [RaiseInvoicePODetailsFormKey.poShortage]: Yup.string(),
    [RaiseInvoicePODetailsFormKey.invoiceDate]: Yup.string().required(
      commonValidationMessages.requiredValidation,
    ),
    [RaiseInvoicePODetailsFormKey.paymentTerms]: Yup.string().required(
      commonValidationMessages.requiredValidation,
    ),
  });

export const invoiceReverseValidationSchema = (
  fetchValidationMessage: (key: string, replacements?: KeyValueMap) => string,
  commonValidationMessages: KeyValueMap,
) => {
  return Yup.object().shape({
    [InvoiceReversalFormKey.reversalReason]: Yup.string().required(
      commonValidationMessages.requiredValidation,
    ),
    [InvoiceReversalFormKey.comments]: Yup.string()
      .max(
        MAX_LENGTH_100,
        commonValidationMessages.maxLengthValidation ||
          "Max 100 characters are allowed.",
      )
      .when(InvoiceReversalFormKey.reversalReason, {
        is: (val: string) =>
          val === INVOICE_REVERSAL_REASON_OTHERS_SITE_CORE_KEY,
        then: (schema) =>
          schema.required(commonValidationMessages.requiredValidation),
        otherwise: (schema) => schema.notRequired(),
      })
      .test(
        EXTENDED_SPECIAL_CHARS,
        fetchValidationMessage(
          commonSiteCoreKeys.fieldContainsInvalidCharactersErrorMessage,
        ),
        (value) =>
          !value ||
          INPUT_LIMIT.ALPHA_NUMERIC_WITH_EXTENDED_SPECIAL_CHARS.test(value),
      ),
  });
};
